import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };
export interface ICartDelete {
  cart_id: string;
  reason: string;
}
export const useSnapmintCancelAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (order_id: string, customer_id: string) => {
      dispatch(
        setLoading({
          key: "isCustomerSnapmintAmountCancelInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${CART_MODULE?.SNAPMINT_CANCEL_API?.baseURL}?order_id=${order_id}&user_id=${customer_id}`, null, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(
                setLoading({
                  key: "isCustomerSnapmintAmountCancelInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Delete Success" };
            } else {
               dispatch(
              setLoading({
                key: "isCustomerSnapmintAmountCancelInProgress",
                status: false,
              }),
            );
              captureError(res.data.message);
              return { status: false, message: "Delete Unsuccessfull" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerSnapmintAmountCancelInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e) {
         dispatch(
              setLoading({
                key: "isCustomerSnapmintAmountCancelInProgress",
                status: false,
              }),
            );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
